import { render, staticRenderFns } from "./GroupChatItemPhotos.vue?vue&type=template&id=91c78072&scoped=true"
import script from "./GroupChatItemPhotos.vue?vue&type=script&lang=js"
export * from "./GroupChatItemPhotos.vue?vue&type=script&lang=js"
import style0 from "./GroupChatItemPhotos.vue?vue&type=style&index=0&id=91c78072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c78072",
  null
  
)

export default component.exports